import React, { useEffect, useState } from "react";

import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import {
    DesvincularEmailContaGrupoController,
    VincularEmailContaGrupoController,
    ListarEmailContaNaoVinculadasPorGrupoController,
    ListarEmailContaVinculadasPorGrupoController,
} from "../../../../../Controllers/Geral/Grupos/GruposEmailsController";
import { IEmailContaGrupo } from "../../../../../Interfaces/Geral/Grupos/GruposEmailsInterfaces";
import { IEmailConta } from "../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";

import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface EmailsProps {
    idGrupo: number;
}

export default function Emails(props: EmailsProps) {
    const [lstEmailsVinculadas, setLstEmailsVinculadas] = useState(
        [] as Array<IEmailContaGrupo>
    );
    const [lstEmailsDesvinculadas, setLstEmailsDesvinculadas] = useState(
        [] as Array<IEmailConta>
    );
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (props.idGrupo !== 0) updateEmails(props.idGrupo);
    }, [props.idGrupo]);

    function updateEmails(idGrupo: number) {
        setLoading(true);
        ListarEmailContaVinculadasPorGrupoController(idGrupo)
            .then((response) => {
                setLstEmailsVinculadas(response);
            })
            .finally(() => setLoading(false));
        ListarEmailContaNaoVinculadasPorGrupoController(idGrupo)
            .then((response) => {
                setLstEmailsDesvinculadas(response);
            })
            .finally(() => setLoading(false));
    }

    //Tabela de Emails Vinculadas
    const columnsEmailsVinculadas: Array<ColumnDescription> = [
        {
            dataField: "DS_USERNAME",
            text: "Emails Vinculadas",
            formatter: RowFuncaoVinculada,
            sort: true,
        },
    ];

    function RowFuncaoVinculada(cell: any, row: IEmailContaGrupo) {
        return (
            <div className="d-flex justify-content-between align-items-center row mx-0 my-4">
                <div className="col-12 mb-2">
                    <label className="mb-1">{row.DS_USERNAME}</label>

                    <div>
                        {row.DS_HOSTNAME_SMTP && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Host SMTP
                                    </Tooltip>
                                }
                            >
                                <span
                                    className={`label abel-pill label-inline label-primary mr-2 mb-1`}
                                >
                                    {row.DS_HOSTNAME_SMTP}{" "}
                                    {row.NR_PORTA_SMTP &&
                                        ` : ${row.NR_PORTA_SMTP}`}
                                </span>
                            </OverlayTrigger>
                        )}
                        {row.DS_HOSTNAME_IMAP && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Host IMAP
                                    </Tooltip>
                                }
                            >
                                <span
                                    className={`label abel-pill label-inline label-info mr-2 mb-1`}
                                >
                                    {row.DS_HOSTNAME_IMAP}{" "}
                                    {row.NR_PORTA_IMAP &&
                                        ` : ${row.NR_PORTA_IMAP}`}
                                </span>
                            </OverlayTrigger>
                        )}
                        {row.FL_SSL && (
                            <span className="label abel-pill label-inline label-success mb1">
                                {" "}
                                SSL{" "}
                            </span>
                        )}
                    </div>
                </div>
                <div className="col-12">
                    <button
                        className="btn btn-sm btn-outline-danger font-weight-bold d-flex align-items-center justify-content-center flex-nowrap w-100"
                        onClick={() => {
                            DesvincularEmailContaGrupoController(
                                row.ID_EMAIL_CONTA_GRUPO
                                    ? row.ID_EMAIL_CONTA_GRUPO
                                    : 0
                            ).finally(() => {
                                updateEmails(props.idGrupo);
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowDown}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Desvincular
                    </button>
                </div>
            </div>
        );
    }
    //Tabela Emails Desvinculadas
    const columnsEmailsDesvinculadas: Array<ColumnDescription> = [
        {
            dataField: "DS_USERNAME",
            text: "Emails Desvinculadas",
            formatter: RowFuncaoDesvinculada,
            sort: true,
        },
    ];

    function RowFuncaoDesvinculada(cell: any, row: IEmailConta) {
        return (
            <div className="d-flex justify-content-between align-items-center row mx-0 my-4">
                <div className="col-12 mb-2">
                    <label className="mb-1">{row.DS_USERNAME}</label>

                    <div>
                        {row.DS_HOSTNAME_SMTP && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Host SMTP
                                    </Tooltip>
                                }
                            >
                                <span
                                    className={`label abel-pill label-inline label-primary mr-2 mb-1`}
                                >
                                    {row.DS_HOSTNAME_SMTP}{" "}
                                    {row.NR_PORTA_SMTP &&
                                        ` : ${row.NR_PORTA_SMTP}`}
                                </span>
                            </OverlayTrigger>
                        )}
                        {row.DS_HOSTNAME_IMAP && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Host IMAP
                                    </Tooltip>
                                }
                            >
                                <span
                                    className={`label abel-pill label-inline label-info mr-2 mb-1`}
                                >
                                    {row.DS_HOSTNAME_IMAP}{" "}
                                    {row.NR_PORTA_IMAP &&
                                        ` : ${row.NR_PORTA_IMAP}`}
                                </span>
                            </OverlayTrigger>
                        )}
                        {row.FL_SSL && (
                            <span className="label abel-pill label-inline label-success mb1">
                                {" "}
                                SSL{" "}
                            </span>
                        )}
                    </div>
                </div>
                <div className="col-12">
                    <button
                        className="btn btn-sm btn-outline-success font-weight-bold d-flex align-items-center justify-content-center flex-nowrap w-100"
                        onClick={() => {
                            VincularEmailContaGrupoController({
                                ID_EMAIL_CONTA: row.ID_EMAIL_CONTA,
                                ID_GRUPO: props.idGrupo,
                                ID_EMAIL_CONTA_GRUPO: 0,
                            }).finally(() => {
                                updateEmails(props.idGrupo);
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Vincular
                    </button>
                </div>
            </div>
        );
    }

    return !loading ? (
        <>
            <h3>Email Conta por grupo</h3>
            <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                <div className="col-12 col-lg-6">
                    <Table
                        keyField="ID_EMAIL_CONTA_GRUPO"
                        columns={columnsEmailsVinculadas}
                        data={lstEmailsVinculadas}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <Table
                        keyField="ID_EMAIL_CONTA"
                        columns={columnsEmailsDesvinculadas}
                        data={lstEmailsDesvinculadas}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
